/**
 * Use backend proxy for S3 (and same-origin) video so it plays in Chrome without CORS issues.
 * S3 bucket host is configured in server; client matches the known trend-spotter bucket.
 */
const S3_VIDEO_HOST = 'showstop-trend-ig.s3.us-east-2.amazonaws.com';

export function getPlayableVideoUrl(url) {
  if (!url || typeof url !== 'string') return url;
  try {
    const u = new URL(url);
    if (u.host === S3_VIDEO_HOST) {
      return `/api/proxy-media?url=${encodeURIComponent(url)}`;
    }
  } catch (_) {}
  return url;
}
